<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <menu-wrapper>
        <template #menu-button="{toggleMenu}">
          <button tabindex="-1" class="btn-filter-operator" @click="toggleMenu">
            <div :class="['icon24', nativeFilterIconClass]" />
          </button>
        </template>
        <template #menu-content>
          <template v-for="(item, i) in filterOperators" :key="i">
            <menu-item
              class="filter-operator-item"
              :class="item.enumValue === operatorValue ? 'active' : ''"
              :icon="['icon24', item.icon]"
              @menu-item-click="filterOperatorItemClick(item)"
            >
              {{ item?.enumText }}
            </menu-item>
          </template>
        </template>
      </menu-wrapper>
    </div>
    <div class="filter-value flex">
      <ms-number
        ref="filterInput"
        v-model="filterValue"
        :read-only="operatorValueReadonly"
        :has-border="false"
        :format-type="col.formatType || col.dataFormat"
        class="w-full ms-input-filter-value"
        @filterGrid="filterHeaderHandle({operator: operatorValue, value: filterValue})"
        :filterSeachGrid="col.filterSeachGrid"
        @keyup.enter="filterHeaderHandle({operator: operatorValue, value: filterValue})"
        @blur="filterHeaderHandle({operator: operatorValue, value: filterValue})"
        @keydown.stop=""
      />
    </div>
  </div>
</template>
<script>
import {defineComponent} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
export default defineComponent({
  name: 'MsThOptionNumber',
  components: {
    MenuItem,
    MenuWrapper,
  },
  extends: msThOptionBase,
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
  },
  setup(props, {emit}) {
    const {
      nativeFilterIconClass,
      operatorValue,
      operatorValueReadonly,
      filterValue,
      filterInput,
      filterHeaderHandle,
      filterOperators,
      removeFilter,
      filterOperatorItemClick,
    } = setup(props, {emit});

    // Hooks

    return {
      nativeFilterIconClass,
      filterOperators,
      operatorValue,
      filterValue,
      filterInput,
      filterHeaderHandle,
      operatorValueReadonly,
      removeFilter,
      filterOperatorItemClick,
    };
  },
});
</script>
